import { getPrecision } from 'helpers/common.helpers'
import { PLINKO_FIXED_ODDS } from './pyramidPlinkogame.constants'
import { times, divide, minus, plus, round } from 'number-precision'
import _, { uniqueId } from 'lodash'
import { moment } from 'config/moment.config'
import { v4 as uuidv4 } from 'uuid'
import { generateClientSeed } from 'utils/common-functions/index'

export const pyramidPlinkoDemoMode = (numberOfBalls, betAmount, riskLevel) => {
  const pyramidGrid = generatePyramidGrid()
  const slotMultipliers = generateSlotMultipliers()
  const ballDrops = []

  for (let i = 0; i < numberOfBalls; i++) {
    const ballDrop = simulateBallDrop(pyramidGrid, riskLevel)
    ballDrops.push(ballDrop)
  }

  const totalWinningAmount = calculateTotalWinningAmount(ballDrops, slotMultipliers, betAmount)

  return {
    ballDrops,
    totalWinningAmount
  }
}

const generatePyramidGrid = () => {
  // Generate a pyramid grid with random pegs
  const grid = []
  for (let i = 0; i < 10; i++) {
    const row = []
    for (let j = 0; j <= i; j++) {
      row.push(Math.random() < 0.5 ? 1 : 0) // 1 represents a peg, 0 represents an empty space
    }
    grid.push(row)
  }
  return grid
}

const generateSlotMultipliers = () => {
  // Generate payout multipliers for each slot
  return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
}

const simulateBallDrop = (pyramidGrid, riskLevel) => {
  // Simulate a ball drop and get the outcome
  let ballPosition = 0
  for (let i = 0; i < pyramidGrid.length; i++) {
    const row = pyramidGrid[i]
    if (Math.random() < 0.5) {
      // Move the ball to the left
      ballPosition = Math.max(0, ballPosition - 1)
    } else {
      // Move the ball to the right
      ballPosition = Math.min(row.length - 1, ballPosition + 1)
    }
    if (row[ballPosition] === 1) {
      // The ball hit a peg, change direction
      if (Math.random() < 0.5) {
        ballPosition = Math.max(0, ballPosition - 1)
      } else {
        ballPosition = Math.min(row.length - 1, ballPosition + 1)
      }
    }
  }
  return ballPosition
}

const calculateTotalWinningAmount = (ballDrops, slotMultipliers, betAmount) => {
  // Calculate the total winning amount based on the ball drops, slot multipliers, and bet amount
  let totalWinningAmount = 0
  for (let i = 0; i < ballDrops.length; i++) {
    const ballDrop = ballDrops[i]
    const slotMultiplier = slotMultipliers[ballDrop]
    totalWinningAmount += betAmount * slotMultiplier
  }
  return totalWinningAmount
}



export const getMultiplierPayout = (numberOfRows, riskLevel, gameSettings) => {
  if (gameSettings) {
    const plinkoPayoutsWithHouseEdge = PLINKO_FIXED_ODDS[numberOfRows][riskLevel - 1].map(odd => {
      const houseEdge = +gameSettings?.houseEdge
      const adjustmentFactor = divide((minus(1, divide(houseEdge, 100))), 0.99)
      const finalOdd = Math.max(0.1, +getPrecision(times(odd, adjustmentFactor), 1))
      return finalOdd >= 10 ? Math.round(finalOdd) : finalOdd
    })
    return plinkoPayoutsWithHouseEdge
  }
  return PLINKO_FIXED_ODDS[numberOfRows][riskLevel - 1]
}

export const getKey = (key) => {
  return `${key}_${uniqueId()}_${new Date().getTime()}`
}

export function plinkoGameResult (numberOfRows) {
  let binaryString = ''

  for (let i = 1; i <= numberOfRows; i++) {
    const probability = Math.round(Math.random())
    binaryString = binaryString.concat(String(parseInt(probability)))
  }

  return binaryString
}

export const getDummyBetResult = (numberOfBalls, numberOfRows, riskLevel, betAmount, gameSettings, clientSeed) => {
  let totalWinningAmount = 0
  const winningSlot = []
  const dropDetails = []
  const selectedOdds = PLINKO_FIXED_ODDS[numberOfRows][(riskLevel === 4 ? 2 : riskLevel - 1)]

  for (let currentBall = 1; currentBall <= numberOfBalls; currentBall++) {
    const result = plinkoGameResult(numberOfRows)
    const totalCountOfOneChar = _.reduce(result, (count, char) => char === '1' ? ++count : count, 0)

    // INFO: Actual odds are calculated based on houseEdge using fixed odds
    // INFO: And if odd is greater then 10, need to increase the value by 1, because below formula won't work perfectly for values greater then 10
    // let actualOdd = Math.max(0.1, times(selectedOdds[totalCountOfOneChar], minus(1, divide(gameSettings.houseEdge, 100))))
    let actualOdd = Math.max(0.1, +getPrecision(times(selectedOdds[totalCountOfOneChar], minus(1, divide(gameSettings.houseEdge, 100))), 1))
    actualOdd = actualOdd > 10 ? Math.floor(actualOdd) + 1 : actualOdd

    const winningAmount = round(times(betAmount, actualOdd), 2)
    const profit = minus(winningAmount, betAmount)
    const actualWinningAmount = profit > gameSettings.maxProfit ? round(plus(betAmount, gameSettings.maxProfit), 2) : winningAmount

    totalWinningAmount = round(plus(totalWinningAmount, actualWinningAmount), 2)

    dropDetails.push(result)
    winningSlot.push(totalCountOfOneChar)
  }

  const totalBetAmount = round(times(betAmount, numberOfBalls), 2)

  return {
    id: uuidv4(),
    userId: 1,
    riskLevel,
    currencyId: '1',
    dropDetails,
    numberOfRows,
    winningSlot,
    numberOfBalls,
    betAmount: totalBetAmount,
    winningAmount: totalWinningAmount,
    result: totalWinningAmount > 0,
    updatedAt: moment().format(),
    createdAt: moment().format(),
    clientSeed,
    serverSeed: generateClientSeed(),
    nextServerSeedHash: uuidv4()
  }
}
